import BaseSetup from '@/components/BaseSetup';

export type SharedButtonCardEmits = {};
export type SharedButtonCardProps = {
	bound?: boolean
	selected?: boolean
	horizontal?: boolean
	icon?: string
	title?: string
	titleShort?: string
	description?: string
	company?: object
	counter?: string
};

export default class SharedButtonCardSetup extends BaseSetup {

	static readonly defaultProps = {};

	get displayedTitle () { return this.props.title ?? this.$t('common.label.button') }
	get displayedTitleShort () { return this.props.titleShort ?? this.$t('common.label.button') }

	constructor (
		private props: SharedButtonCardProps,
		private emits: SharedButtonCardEmits,
	) {
		super();
	}

}
